/* Ethos Shoes — Bakım Kılavuzu sekme geçişi.
   care-guide.liquid içinden ayrıldı; anasayfa bölümü ve ürün detay popup'ı
   aynı dosyayı kullanır. customElements.get kontrolü çift yüklemeye karşı. */
if (!customElements.get('care-guide')) {
  customElements.define('care-guide', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.care-guide__tab').forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetId = tab.dataset.target;
          this.querySelectorAll('.care-guide__tab').forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          this.querySelectorAll('.care-guide__panel').forEach((p) => p.classList.remove('is-active'));
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          const panel = this.querySelector('#' + targetId);
          if (panel) panel.classList.add('is-active');
        });
      });
    }
  });
}
